import React from 'react'
import './../../App.css'
import vectorshape from './../../Images/vector-shape6-571a738d8be912721121ee3a3d3a05a3.png'
export default function Projectarea(props) {
  return (
      <div className='pt-100 pb-70 project_area' style={{ backgroundColor:"#fafafb" , position:"relative"}}>
      <div className="container">
              <div className="section_title">
                  <h2>{props.projecttitle}</h2>
              </div>
              <div className="row col-lg-12 col-md-12">
                  <p className="coursedescription" style={{
                      textAlign: 'center'  ,   color: 'red',
                      fontSize: '2.5vh'}}>
                      {props.coursedescription}
                </p>
              </div>
      </div>
      <div className="vector-shape">
        <img src={vectorshape}/>
      </div>
    </div>
  )
}
